export default __webpack_public_path__ + "17451a4c1cd55e33ac57c3a441d42f61.ttf";